import { type MCPServerInfo } from '../../types';

const CustomApiServerServer: MCPServerInfo = {
  serverId: 'CUSTOM_API_SERVER',
  name: 'Custom API Spec',
  slug: 'custom-api-server',
  description: 'Create an MCP server from a custom OpenAPI spec.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'mcp/custom-api-server:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: '@tyk-technologies/api-to-mcp'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {
      spec: {
        type: 'string',
        description: 'Path to OpenAPI spec file',
        sensitive: false
      },
      overlays: {
        type: 'string',
        description: 'Comma-separated paths to overlay JSON files',
        sensitive: false
      },
      targetUrl: {
        type: 'string',
        description: 'Base URL for API calls (overrides OpenAPI servers)',
        sensitive: false
      },
      whitelist: {
        type: 'string',
        description:
          'Comma-separated list of operation IDs or URL paths to include',
        sensitive: false
      },
      blacklist: {
        type: 'string',
        description:
          'Comma-separated list of operation IDs or URL paths to exclude (ignored if whitelist used)',
        sensitive: false
      },
      apiKey: {
        type: 'string',
        description: 'API Key for the target API (if required)',
        sensitive: true
      },
      securityScheme: {
        type: 'string',
        description: 'Name of the security scheme requiring the API Key',
        sensitive: false
      },
      securityCredentials: {
        type: 'string',
        description:
          'JSON string containing security credentials for multiple schemes',
        sensitive: true
      },
      customHeaders: {
        type: 'string',
        description:
          'JSON string containing custom headers to include in all API requests',
        sensitive: false
      }
    }
  }
};

export default CustomApiServerServer;
